import React, { ReactElement } from 'react';
import { Row, Col } from 'antd';
import { PieChart } from 'react-minimal-pie-chart';
import './c-pie-chart.less';

const CPieChart = ({data, hideLabels = false}: any): ReactElement => {
  return (
    <Row>
      <Col className="pie-chart-wrapper" span={`${hideLabels ? '24' : '10'}`}>
        <PieChart
          data={data}
          animate={false}
        />
      </Col>
      {!hideLabels &&
        <Col span={14} className="chart-label-wrapper">
        <ul className="chart-labels">
          {data && data.length > 0 &&
            data.map((d: any, index: number): ReactElement =>
              <li className={d.title} key={index}>{d.value} {d.title}</li>,
            )
          }
        </ul>
      </Col>}
    </Row>
  );
};

export default CPieChart;
